type ProcedureKeys = 'logout';

class GlobalProcedures {
  procedureMap;

  private static instance: GlobalProcedures;

  constructor() {
    // eslint-disable-next-line @typescript-eslint/ban-types
    this.procedureMap = new Map<ProcedureKeys, Function>();
  }

  register(key: ProcedureKeys, fn: () => Promise<void>): void {
    this.procedureMap.set(key, fn);
  }

  deregister(key: ProcedureKeys): void {
    this.procedureMap.delete(key);
  }

  public static getInstance(): GlobalProcedures {
    if (!GlobalProcedures.instance) {
      GlobalProcedures.instance = new GlobalProcedures();
    }
    return GlobalProcedures.instance;
  }
}

export default GlobalProcedures;
